import React from 'react';
import { Tag, Space } from 'antd';
import type { VehicleFilter } from '../api/generated';
import { formatFilterLabel } from '../utils/filterFormatters';

interface FilterPillsProps {
  filters: VehicleFilter[];
  maxVisible?: number;
}

export const FilterPills: React.FC<FilterPillsProps> = ({
  filters,
  maxVisible = 4
}) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  const visibleFilters = filters.slice(0, maxVisible);
  const remainingCount = filters.length - maxVisible;

  return (
    <Space size={4} wrap>
      {visibleFilters.map((filter, index) => (
        <Tag key={index} color="blue">
          {formatFilterLabel(filter)}
        </Tag>
      ))}
      {remainingCount > 0 && (
        <Tag color="default">
          +{remainingCount}
        </Tag>
      )}
    </Space>
  );
};
